<template>
  <div class="comment-overlay" v-if="visibleEntries.length">
    <TransitionGroup name="comment-toast">
      <div
        v-for="entry in visibleEntries"
        :key="entry.id"
        class="comment-toast"
      >
        <span class="toast-avatar" :style="{ background: entry.avatarColor }">
          {{ entry.avatarInitials }}
        </span>
        <div class="toast-body">
          <div class="toast-header">
            <strong>{{ entry.author }}</strong>
            <span class="toast-time">{{ formatTime(entry.timestamp) }}</span>
          </div>
          <p class="toast-text">{{ entry.text }}</p>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatTimestamp as formatTime } from '@/utils/reviewUtils'

const POINT_DISPLAY_SECONDS = 4

const props = defineProps({
  comments: {
    type: Array,
    default: () => [],
  },
  currentTime: {
    type: Number,
    default: 0,
  },
})

const visibleEntries = computed(() => {
  const time = props.currentTime
  return props.comments.filter(c => {
    if (c.timestamp == null) return false
    if (c.timestampEnd != null) {
      return time >= c.timestamp && time <= c.timestampEnd
    }
    return time >= c.timestamp && time < c.timestamp + POINT_DISPLAY_SECONDS
  })
})
</script>

<style lang="scss" scoped>
.comment-overlay {
  position: absolute;
  bottom: 3.5rem;
  right: 0.75rem;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.4rem;
  max-width: 320px;
  pointer-events: none;
}

.comment-toast {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 0.5rem 0.65rem;
  border-radius: 0.5rem;
  font-size: 0.78rem;
  line-height: 1.35;
  max-width: 100%;
  pointer-events: auto;
}

.toast-avatar {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6rem;
  font-weight: 700;
  color: #fff;
  margin-top: 1px;
}

.toast-body {
  min-width: 0;
}

.toast-header {
  display: flex;
  align-items: baseline;
  gap: 0.4rem;
  margin-bottom: 2px;

  strong {
    font-size: 0.78rem;
  }
}

.toast-time {
  font-size: 0.65rem;
  opacity: 0.6;
  flex-shrink: 0;
}

.toast-text {
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  opacity: 0.92;
}

/* Transition */
.comment-toast-enter-active {
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

.comment-toast-leave-active {
  transition: all 0.3s ease-in;
}

.comment-toast-enter-from {
  opacity: 0;
  transform: translateX(24px);
}

.comment-toast-leave-to {
  opacity: 0;
  transform: translateX(16px) scale(0.95);
}

.comment-toast-move {
  transition: transform 0.3s ease;
}
</style>
